import { render, staticRenderFns } from "./detail_content.vue?vue&type=template&id=5b9ea5a8&scoped=true"
import script from "./detail_content.vue?vue&type=script&lang=js"
export * from "./detail_content.vue?vue&type=script&lang=js"
import style0 from "./detail_content.vue?vue&type=style&index=0&id=5b9ea5a8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9ea5a8",
  null
  
)

export default component.exports